import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Divider from '../../common/atoms/Divider';
import { TEXT_INPUT_OPTIONS } from '../../common/molecules/TextInput';
import KeywordInput from '../../atoms/KeywordInput';
import SearchAreaInput from '../../atoms/SearchAreaInput';
import Button, { BUTTON_OPTIONS } from '../../common/atoms/Button';
import useHorizontalSearchBarLogic from './useHorizontalSearchBarLogic';
import SearchForm from '../../atoms/SearchForm';
import useDataLayerPush from '../../../../hooks/useDataLayerPush';
import { DATA_PUSH } from '../../constants';

const HORIZONTAL_SEARCH_BAR_CONSTS = {
  DIVIDER_SIZE: '40px',
  INPUT_SIZE: TEXT_INPUT_OPTIONS.SIZES.XL,
  SEARCH_BUTTON: {
    COLOR: BUTTON_OPTIONS.COLORS.PRIMARY,
    SIZE: BUTTON_OPTIONS.SIZES.XL,
    TEXT: 'Search',
    TYPE: 'submit',
  },
};

const StyledContainer = styled.div`
  align-items: center;
  display: flex;
  position: relative;
  width: 100%;
`;

const StyledSearchAreaInput = styled(SearchAreaInput)`
  max-width: 30%;
  width: 30%;
`;

const StyledKeywordInput = styled(KeywordInput)`
  flex-grow: 1;
  margin-left: ${props => props.theme.margin.small};
`;

const HorizontalSearchBar = forwardRef(({ className,onSearch }, ref) => {
  const { submitButtonDisabled } = useHorizontalSearchBarLogic();

  return (
    <SearchForm>
      <StyledContainer className={className} ref={ref}>
        <StyledSearchAreaInput size={HORIZONTAL_SEARCH_BAR_CONSTS.INPUT_SIZE} />
        <Divider size={HORIZONTAL_SEARCH_BAR_CONSTS.DIVIDER_SIZE} />
        <StyledKeywordInput size={HORIZONTAL_SEARCH_BAR_CONSTS.INPUT_SIZE} />
        <Button
          color={HORIZONTAL_SEARCH_BAR_CONSTS.SEARCH_BUTTON.COLOR}
          disabled={submitButtonDisabled}
          size={HORIZONTAL_SEARCH_BAR_CONSTS.SEARCH_BUTTON.SIZE}
          text={HORIZONTAL_SEARCH_BAR_CONSTS.SEARCH_BUTTON.TEXT}
          type={HORIZONTAL_SEARCH_BAR_CONSTS.SEARCH_BUTTON.TYPE}
          handleClick={onSearch}
        />
      </StyledContainer>
    </SearchForm>
  );
});

const horizontalSearchBarPropTypes = {
  className: PropTypes.string,
};
const horizontalSearchBarDefaultProps = {
  className: undefined,
};

HorizontalSearchBar.propTypes = horizontalSearchBarPropTypes;
HorizontalSearchBar.defaultProps = horizontalSearchBarDefaultProps;
export default HorizontalSearchBar;
export { horizontalSearchBarDefaultProps, horizontalSearchBarPropTypes };
